import { Box, Button, TextField, Typography } from "@mui/material";
import Label from "app/components/NewItemForm/components/Label";
import PostScript from "app/components/NewItemForm/components/PostScript";
import { Field, Form, Formik } from "formik";
import { useImportFareharborMutation } from "lib/features/business/businessService";
import { Business } from "lib/features/business/types";
import { selectUser } from "lib/features/user/userSlice";
import { useAppSelector } from "lib/hooks";
import { useEffect, useState } from "react";
import businessServices from "services/business-service";
import { createBusinessListStyles } from "styles/BusinessListDirectory/createBusinessList.styles";
import * as Yup from "yup";
import FHErrorModal from "./FHErrorModal";
import FHSuccesModal from "./FHSuccesModal";

const validationSchema = Yup.object().shape({
  shortName: Yup.string().required("Shot name is required"),
});

const FareharborForm = () => {
  const user = useAppSelector(selectUser);
  const [businessData, setBusinessData] = useState<Business[]>();

  const [formValues, setFormValues] = useState({
    shortName: "",
  });

  const [successModalOpen, setSuccessModalOpen] = useState<boolean>(false);
  const [errorModalOpen, setErrorModalOpen] = useState<boolean>(false);

  const [importFareharbor, { isLoading }] = useImportFareharborMutation();

  const onSubmit = async (values: any) => {
    if (!businessData?.[0]?.id) return;
    try {
      const response = await importFareharbor({
        id: businessData[0].id,
        shortname: values.shortName,
      }).unwrap();

      response ? setSuccessModalOpen(true) : setErrorModalOpen(true);
    } catch (error) {
      console.log("error: ", error);
    }
  };

  useEffect(() => {
    const fetchBusiness = async () => {
      if (!user?.id) return;
      try {
        const response = await businessServices.getUserBusiness(user.id);
        setBusinessData(response?.data);
      } catch (err) {
        console.log("error fetching business");
      }
    };

    fetchBusiness();
  }, [user?.id]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      width="100%"
      marginY="1rem"
    >
      <Box
        sx={{
          maxWidth: {
            xs: "90vw", // small
            sm: "70vw", // tab
            md: "40vw", // large
          },
        }}
        width="100%"
      >
        <Formik
          initialValues={formValues}
          validationSchema={validationSchema}
          onSubmit={(values) => onSubmit(values)}
        >
          {({ errors, touched, setFieldValue }) => {
            const handleChange = (e: React.ChangeEvent<any>) => {
              const { name, value } = e.target;
              setFieldValue(name, value);
              setFormValues((prevValues: any) => ({
                ...prevValues,
                [name]: value,
              }));
            };

            return (
              <Form>
                <Box>
                  {/* Item Name */}
                  <Box>
                    <Label label="FareHarbor Shortname" required={true} />
                    <Field
                      as={TextField}
                      name="shortName"
                      fullWidth
                      onChange={handleChange}
                      error={touched.shortName && Boolean(errors.shortName)}
                    />
                    {errors.shortName && touched.shortName && (
                      <Typography color="red" fontSize="12px">
                        {errors.shortName}
                      </Typography>
                    )}
                    <PostScript text="Type in the Shortname you use to login to your Fareharbor Account and click “Start Import”" />
                  </Box>

                  <Button
                    type="submit"
                    variant="contained"
                    sx={createBusinessListStyles.actionBtn}
                    disabled={isLoading}
                  >
                    Start Import
                  </Button>
                </Box>
              </Form>
            );
          }}
        </Formik>

        <FHSuccesModal
          open={successModalOpen}
          close={() => setSuccessModalOpen(false)}
        />

        <FHErrorModal
          open={errorModalOpen}
          close={() => setErrorModalOpen(false)}
        />
      </Box>
    </Box>
  );
};
export default FareharborForm;
